var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgTelephoneFill = function SvgTelephoneFill(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50,0 C22.4298175,0 0,22.4301814 0,50.0001024 C0,77.5700233 22.4300224,100 50,100 C77.5699776,100 100,77.5714581 100,50.0013319 C100,22.4312061 77.5699776,0 50,0 L50,0 Z M67.7332541,76 C50.1426777,76 24,47.7686196 24,32.9398565 C24,27.0114211 29.0516819,23 33.2679669,23 C37.7261658,23 45.324459,36.0086864 45.324459,38.7599197 C45.324459,40.6980521 44.4973092,42.0693936 43.8341843,43.1721739 C43.3183866,44.027305 43.0140598,44.5617491 42.9806643,45.1778844 C43.6646614,47.3424449 51.6688934,55.4172069 53.929301,56.2301017 C54.5299111,56.1767397 55.290168,55.7758036 56.0937985,55.3525131 C57.3532571,54.6885788 58.9213191,53.8615708 60.8369789,53.8615708 C63.8993884,53.8615708 77,62.5073474 77,66.0615859 C77.0014242,72.8198108 73.1951509,76 67.7334576,76 L67.7332541,76 Z"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgTelephoneFill);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "telephone-fill.81721a4111072db4924ee14d2fc8fc0a.svg";